<template>
  <loading
    v-bind="$attrs"
    v-on="$listeners"
    :active="active"
    @update:active="$emit('update:active', $event)"
  >
    <template #default>
      <div class="custom-loading-wrapper">
        <div class="custom-loading-spinner"></div>
        <img src="@/assets/logo/logo-nextpay.png" class="loading-logo" />
      </div>
    </template>
  </loading>
</template>

<script>
  import Loading from 'vue-loading-overlay'

  export default {
    name: 'VueLoadingOverlayCustom',
    components: {
      Loading,
    },
    props: {
      active: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>

<style scoped>
  .custom-loading-wrapper {
    position: relative;
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .custom-loading-spinner {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 4px solid rgba(50, 205, 50, 0.2); /* Light green with opacity */
    border-top-color: #32cd32; /* Lime green */
    animation: spin 1s linear infinite;
    box-sizing: border-box;
  }

  .loading-logo {
    width: 45px;
    height: auto;
    position: relative;
    z-index: 1;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>
